


import { Component, AfterViewInit, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { NgbModal, NgbTooltip, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, NgIf } from '@angular/common';
//declare var $: any;
import { MenuService } from '../../services/menu.service';


import { AuthService } from '../../services/auth/auth.service';
import { TRANSLATIONS_EN } from 'src/app/i18n/translations.en';
import { TRANSLATIONS_HI } from 'src/app/i18n/translations.hi';
import { RouteInfo } from 'src/app/shared/sidebar/sidebar.metadata';
// sidebar.component.ts


// NavItem is just a type, never a value
interface NavItem {
  icon: string;
  label: string;
  route: string;
  active?: boolean;
  children?: NavItem[];
  expanded?: boolean;
}



@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule, NgIf, NgbTooltipModule ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  isAuthenticated: Boolean = false;
  public sidebarnavItems: RouteInfo[] = [];
  navItems: NavItem[] = [];
  roleId: any;
  // this is for the open close
  addExpandClass(element: string) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  @Input() collapsed = false;
  @Output() toggleSidebar = new EventEmitter<void>();

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService,
    private authService: AuthService
  ) { }
  menuItems: any[] = [];
  currentDate: Date = new Date();
societyId:any;
  // End open close
  ngOnInit() {
    this.authService.currentUserSubject.subscribe((r) => {
      this.isAuthenticated = r

    });
    setInterval(() => {
      this.currentDate = new Date();
    }, 1000);

    this.authService.currentUserSubject.subscribe((user: any) => {
      this.isAuthenticated = !!user;
      this.userName = user?.firstName || 'Guest';
      this.roleName = user?.roleName || '';
      this.roleId = user?.roleId;
      this.societyId = Number(user?.societyId);

    if (this.authService?.currentUserValue && this.authService.currentUserValue.roleId === 9 && this.authService.currentUserValue.registrationNo === null) {
    }
    else {
      if (this.isAuthenticated) {
        
        this.getMenu();
      }
    }
       

    });
  }

  // Display only: Society User + Act year for role 9.--Added by Ranjit role+ yr
  get displayRoleName(): string {
    if (Number(this.roleId) === 9) {
      if (Number(this.societyId) === 1) {
        return 'Society User 2006';
      }
      if (Number(this.societyId) === 2) {
        return 'Society User 1968';
      }
    }
    return this.roleName || '';
  }


// getMenu() {
//   this.menuService.getMenuForHeader().subscribe({
//     next: (response) => {
//       this.menuItems = response.data;
     
      
//       this.navItems = this.transformMenu(response.data);
//       this.navItems.forEach(item => {
//       if (item.children && item.children.length > 0) {
//         item.expanded = false;
//       }
//     });
//     },
//     error: (error) => {
//       console.error('Error: ', error);
//     },
//   });
// }

getMenu() {
 
  this.menuService.getMenuForHeader().subscribe({
    next: (response) => {

      let data = response.data;

      if (this.societyId === 1 && this.roleId === 9) {
        const allowedMenu = [1, 20,131];
        data = data.filter((item: any) => allowedMenu.includes(item.id));
      }

      this.menuItems = data;
      this.navItems = this.transformMenu(data);

      this.navItems.forEach(item => {
        if (item.children && item.children.length > 0) {
          item.expanded = false;
        }
      });

    },
    error: (error) => {
      console.error('Error: ', error);
    },
  });
}


transformMenu(menuData: any[]): NavItem[] {
  return menuData
    .filter(item => item.isVisible !== false)
    .map(item => ({
      icon: item.className?.startsWith('bi')
        ? item.className
        : 'bi bi-list',

      label: item.menuName,
      route: item.menuLink && item.menuLink !== '#' ? item.menuLink : '',
      expanded: false,
      active: false,

      children: item.children && item.children.length
        ? this.transformMenu(item.children)
        : []
    }));
}

  openIndex: number | null = null;

  setOpen(index: number) {
    this.openIndex = index;
  }

  closeMenu() {
    this.openIndex = null;
  }
toggle(item: any): void {
  item.expanded = !item.expanded;
}
  isOpen(index: number): boolean {
    return this.openIndex === index;
  }
  getVisibleMenu(item: any): any[] {

    return item.children?.filter((x: any) => x.isVisible === true) || [];
  }
  isEnglish = true;

  mobileMenuOpen = false;
  // Translations
  translations = TRANSLATIONS_EN;
  userName = this.authService?.currentUserValue?.firstName || 'Guest';
  roleName = this.authService?.currentUserValue?.roleName || '';
  toggleLanguage(): void {
    this.isEnglish = !this.isEnglish;
    this.translations = this.isEnglish
      ? TRANSLATIONS_EN
      : TRANSLATIONS_HI;
  }

}
